import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { fetchActivities } from 'reducers/farmfeed';
import { setSearch, setSearchText } from 'reducers/farmFeedSearch';
import { openPortal } from 'reducers/portal';
import { openPortalRight } from 'reducers/rightToLeftPortal';
// components
import FarmFeedAutoSuggestMobile from './FarmFeedAutoSuggestMobile/FarmFeedAutoSuggestMobile';
import PigPulsePanel from 'components/PigPulse/PigPulsePanel';
import PigPulseIcon from 'components/PigPulse/PigPulseIcon';
// api
import { searchActivities } from 'endpoints/farmfeed';
// utils
import cn from 'classnames';
import { isPigPulseAvailable } from 'utils/pigPulseHelper';
// assets
import './FarmFeedSearchMobile.scss';

const FarmFeedSearchMobile = ({
  farmFeedParams,
  fetchActivities,
  openPortal,
  openPortalRight,
  setSearch,
  setSearchText,
  user,
}) => {
  const getSearchEntity = (value) => {
    const params = value.type === 'search'
      ? { search: value.text, filters: {} }
      : { filters: { [`${value.type}_id`]: value.id }, search: '' };
    fetchActivities({ ...farmFeedParams, ...params });
    setSearch(params);
    setSearchText(value.type === 'search' ? value.text : value.name);
  };

  const openPortalSearch = () => {
    openPortal(
      <FarmFeedAutoSuggestMobile
        getSuggestions={(search) => searchActivities({ search })}
        onSelect={getSearchEntity}
      />
    );
  };

  return (
    <span className="mobile-search-icons">
      <i className={cn('fa fa-search ', 'init-search')} onClick={openPortalSearch} />
      {isPigPulseAvailable(user) && (
        <PigPulseIcon
          className={cn('init-search', 'pigpulse-init')}
          size={24}
          onClick={() => openPortalRight(<PigPulsePanel />)}
        />
      )}
    </span>
  );
};

FarmFeedSearchMobile.propTypes = {
  openPortal: T.func.isRequired,
  openPortalRight: T.func.isRequired,
  fetchActivities: T.func.isRequired,
  setSearch: T.func.isRequired,
  setSearchText: T.func.isRequired,
  farmFeedParams: T.object.isRequired,
  user: T.object,
};

export default connect(
  (state) => ({
    farmFeedParams: state.farmfeed.params,
    user: state.auth.user,
  }), {
    fetchActivities,
    setSearch,
    setSearchText,
    openPortal,
    openPortalRight,
  }
)(FarmFeedSearchMobile);
